import React from 'react';

import { Button } from './styles';

interface TableActionButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export const TableActionButton = ({
  label,
  icon,
  onClick,
}: TableActionButtonProps) => (
  <Button type="button" onClick={onClick} aria-label={label} title={label}>
    {icon}
  </Button>
);
